import { useQuery } from "@apollo/client/react";

import { queries } from "@/api";

import { useSession } from "@/contexts/session";

/**
 * The combination of session (from window.localStorage) & the account queried
 * from the API. Specifically for identifying users for analytics, logging etc.
 */
const useAuthenticatedUser = () => {
	const { hasAuthenticatedSession } = useSession();
	// Not asked while signed out: the answer is discarded below anyway, and an
	// anonymous request still in flight when the visitor signs in could land
	// after the authenticated one and leave a cache-complete `account: null`
	// that nothing would ask again about.
	const { data = {} } = useQuery(queries.ME, {
		skip: !hasAuthenticatedSession,
	});
	const { account = null } = data;

	// An "empty" account in the cache exists, but its id doesn't have a value
	if (hasAuthenticatedSession && account?.id) {
		return account;
	}

	return null;
};

export default useAuthenticatedUser;
